import {
  CreateHealthRecordBodyHealthRecordGenderEnum,
  HealthRecord as ProHealthRecord,
  HealthRecordApiInterface as ProHealthRecordApiInterface,
} from "@syadem/kairos-pro-js";
import {
  HealthRecord as TeamHealthRecord,
  HealthRecordApiInterface as TeamHealthRecordApiInterface,
} from "@syadem/kairos-team-js";
import { Success } from "../actionResult";
import { AppStore, updateHealthRecord } from "../store";
import { Service } from "./service";

interface Payload {
  healthRecord: {
    externalId: string | null;
    firstNames: string;
    lastName: string;
    customaryName: string | null;
    birthDate: Date;
    gender: CreateHealthRecordBodyHealthRecordGenderEnum;
    zipCode: string | null;
    birthCountryCode: string | null;
    birthCityCode: string | null;
  };
  organizationId: string | null;
  teamId: string | null;
}

export class CreateHealthRecordService implements Service<Payload, ProHealthRecord | TeamHealthRecord> {
  constructor(
    private readonly store: AppStore,
    private readonly proHealthRecordApi: ProHealthRecordApiInterface,
    private readonly teamHealthRecordApi: TeamHealthRecordApiInterface,
  ) {}

  async call({ healthRecord, organizationId, teamId }: Payload): Promise<Success<ProHealthRecord | TeamHealthRecord>> {
    let apiHealthRecord: ProHealthRecord | TeamHealthRecord;
    if (organizationId && teamId) {
      apiHealthRecord = (await this.teamHealthRecordApi.createHealthRecord(organizationId, teamId, { healthRecord }))
        .healthRecord;
    } else {
      apiHealthRecord = (await this.proHealthRecordApi.createHealthRecord({ healthRecord })).healthRecord;
    }

    this.store.setState(updateHealthRecord(apiHealthRecord, teamId));

    return {
      type: "success",
      value: apiHealthRecord,
    };
  }
}
